import { type LetterFileTagDto } from "../app/dto/letter-file-tag.dto";
import { crudStoreFactory, type PastaCrudStoreState } from "@pasta/box-v2";
import { useAdminTagsApi } from "./admin-tags.api";

export const useAdminTagsStore = crudStoreFactory("admin-tags", useAdminTagsApi, storeDef => {
  return {
    ...storeDef,
    state: (): PastaCrudStoreState<LetterFileTagDto> => {
      return {
        list: {
          data: [],
          isLastPage: true,
          limit: 0,
          offset: 0,
          page: 1,
          total: 0,
        },
        map: new Map<number, LetterFileTagDto>(),
      };
    },
    actions: {
      ...storeDef.actions,
    },
  };
});
